import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'questionnaireResponses',
  inputShow: gql`
    query questionnaireResponses($input: QuestionnaireResponseQueryInput) {
      questionnaireResponses(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'License',
    label: 'Questionnaire Responses',
    order: 4,
  },
};
